// extracted by mini-css-extract-plugin
export default {"container":"CreateList_container__aBY1-"};